module.exports = __webpack_public_path__ + "static/media/Book-Appointment-Icon-Chartreuse.0d6af677.svg";